import { injectIntl } from "react-intl";
import React, { useEffect, useState } from "react";
import TableHeader from "src/components/TableHeader";
import {
    TAG_TABLE_TITLE_SORT,
    TAG_TABLE_TITLE_WIDTHS,
    TAG_TABLE_TITLES
} from "src/helpers/Constants";
import { OperationType, TagTableSortType } from "src/helpers/Enums";

const TagTable = (props) => {

    const [sortedList, setSortedList] = useState(props.list)

    useEffect(() => {
        setSortedList(props.list)
    }, [props.list])

    return (
        <div className={ "w-full flex flex-col gap-3" }>
            <TableHeader titles={ TAG_TABLE_TITLES } widths={ TAG_TABLE_TITLE_WIDTHS }
                         sort={ TAG_TABLE_TITLE_SORT } sortedList={ sortedList }
                         sortType={ TagTableSortType }
                         setSortedList={ setSortedList }/>
            <div className="TableWrapper">
                <table className="Table">
                    <tbody>
                    { sortedList?.map((item, index) => (
                        <tr key={ index } className="border-b h-[60px] hover:bg-[#F6F6F9]">
                            <td className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                                style={ {width: TAG_TABLE_TITLE_WIDTHS[0]} }>
                                <div className={"flex h-[26px] px-[6px] items-center gap-1 rounded-sm bg-[#F6F6F9] w-fit"}>
                                    <img alt={ "Logo" } src={ "/media/icons/tag.svg" }
                                         className={ "h-3 w-3" }/>{ item.name }</div>
                                </td>
                            <td className="py-3 px-4 flex justify-center items-center">
                                <button className="StrategyEditButton"
                                        onClick={ () => props.handleOpenNewTag(OperationType.UPDATE, item) }>
                                    <img alt={ "Logo" } src={ "/media/icons/editIcon.svg" } className={ "w-4 h-4" }/>
                                    Edit
                                </button>
                                <button className="StrategyDeleteButton"
                                        onClick={ () => props.handleOpenDeleteTag(item) }>
                                    <img alt={ "Logo" } src={ "/media/icons/deleteIcon.svg" } className={ "w-4 h-4" }/>
                                    Delete
                                </button>
                            </td>
                        </tr>
                    )) }
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default injectIntl(TagTable);
